import { Controller } from "@hotwired/stimulus";

// Copies the current values of a filter form into this form right before it
// submits. The import button is rendered by an earlier response, so without
// this its hidden fields still hold the filters as they were at render time —
// clicking it while a filter change is still in flight would import the
// unfiltered set.
//
//   data-controller="filter-params"
//   data-action="submit->filter-params#sync"
//   data-filter-params-source-value="#some_form"
//   data-filter-params-fields-value='["activity_type_ids[]"]'
export default class extends Controller {
  static values = { source: String, fields: Array };

  sync() {
    const source = document.querySelector(this.sourceValue);
    if (!source) return;

    const formData = new FormData(source);

    this.fieldsValue.forEach((field) => {
      this.element
        .querySelectorAll(`input[type="hidden"][name="${field}"]`)
        .forEach((input) => input.remove());

      formData
        .getAll(field)
        .filter((value) => value !== "")
        .forEach((value) => this.element.appendChild(this.hiddenField(field, value)));
    });

    source.dispatchEvent(new CustomEvent("filter-params:synced"));
  }

  hiddenField(name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }
}
